import type { IconNode } from '../types';

/**
 * @name gearbox
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNSA0djE2IiAvPgogIDxwYXRoIGQ9Ik0xMiA0djE2IiAvPgogIDxwYXRoIGQ9Ik0xOSA0djhINSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/gearbox
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const gearbox: IconNode = [
  ['path', { d: 'M5 4v16', key: '10bc4i' }],
  ['path', { d: 'M12 4v16', key: '1654pz' }],
  ['path', { d: 'M19 4v8H5', key: '1jiz4h' }],
];

export default gearbox;
